import { render, staticRenderFns } from "./MediaImageImg50tit10txt40.vue?vue&type=template&id=ca1dc8d6&scoped=true"
import script from "./MediaImageImg50tit10txt40.vue?vue&type=script&lang=js"
export * from "./MediaImageImg50tit10txt40.vue?vue&type=script&lang=js"
import style0 from "./MediaImageImg50tit10txt40.vue?vue&type=style&index=0&id=ca1dc8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1dc8d6",
  null
  
)

export default component.exports